interface ProgressBarProps {
  /** New API: 0-100 percent */
  percent?: number
  /** Legacy API: raw value */
  value?: number
  /** Legacy API: max value */
  max?: number
  gradient?: string
  trackColor?: string
  height?: number
  label?: string
  showValue?: boolean
  color?: 'primary' | 'xp' | 'streak' | 'tucoin' | 'success' | 'warning'
  size?: 'small' | 'medium' | 'large'
  animated?: boolean
}

const COLOR_MAP: Record<string, string> = {
  primary: 'linear-gradient(90deg, #1A3A5C, #4A6CF7)',
  xp: 'linear-gradient(90deg, #FFD60A, #FF9500)',
  streak: 'linear-gradient(90deg, #FF9500, #F97316)',
  tucoin: 'linear-gradient(90deg, #AF52DE, #7C3AED)',
  success: '#34C759',
  warning: '#FF9500',
}

const SIZE_MAP: Record<string, number> = {
  small: 4,
  medium: 8,
  large: 12,
}

export function ProgressBar({
  percent,
  value,
  max,
  gradient,
  trackColor = 'rgba(26,58,92,0.06)',
  height,
  label,
  showValue = false,
  color = 'primary',
  size = 'medium',
}: ProgressBarProps) {
  const pct = percent !== undefined
    ? Math.min(100, Math.max(0, percent))
    : value !== undefined && max
      ? Math.min(100, Math.max(0, (value / max) * 100))
      : 0

  const h = height ?? SIZE_MAP[size] ?? 8
  const bg = gradient ?? COLOR_MAP[color] ?? COLOR_MAP.primary

  return (
    <div>
      {(label || (showValue && value !== undefined && max)) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          {label && <span style={{ fontSize: 13, color: '#6B7B8D' }}>{label}</span>}
          {showValue && value !== undefined && max && (
            <span style={{ fontSize: 13, color: '#6B7B8D' }}>
              {value} / {max}
            </span>
          )}
        </div>
      )}
      <div style={{ height: h, borderRadius: h / 2, background: trackColor, width: '100%' }}>
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            borderRadius: h / 2,
            background: bg,
            transition: 'width 0.3s ease',
          }}
        />
      </div>
    </div>
  )
}
